import initHeader from "./initHeader.js";

const initModals = () => {

    const body = document.body;
    const dialogs = document.querySelectorAll('dialog');
    const openModalButtons = document.querySelectorAll('[data-toggle-modal]');

    const { closeMenu } = initHeader();

    const closeAllModals = () => {
        dialogs.forEach(dialog => {
            if (dialog.open) dialog.close();
        });
        body.style.paddingRight = '0';
        body.classList.remove('overflow-hidden');
    };

    const handleOpenModal = (btn) => {
        closeAllModals();
        // console.log('Closing menu before opening modal');
        closeMenu();

        const targetSelector = btn.dataset.targetModal;
        const dialog = document.querySelector(targetSelector);

        // console.log('Opening modal:', targetSelector, dialog);

        if (!dialog) {
            console.warn('Modal not found:', targetSelector);
            return;
        }

        body.style.paddingRight = window.innerWidth - body.clientWidth + 'px';
        body.classList.add('overflow-hidden');
        dialog.showModal();

        if (btn.dataset.id) {
            const input = dialog.querySelector('[name="id"]');
            if (input) input.value = btn.dataset.id;
        }
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Modal open handlers
    // -----------------------------------------------------------------------------------------------------------------
    openModalButtons.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            handleOpenModal(btn);
        });
    });

    // -----------------------------------------------------------------------------------------------------------------
    // Modal close handlers
    // -----------------------------------------------------------------------------------------------------------------
    dialogs.forEach(dialog => {
        dialog.addEventListener('mousedown', e => {
            // безопасно получаем ближайшую кнопку (может быть null)
            const btn = e.target.closest && e.target.closest('button');

            // если клик по кнопке с data-close-dialog — закрываем
            if (btn && btn.hasAttribute('data-close-dialog')) {
                closeAllModals();
                return;
            }

            // если клик по самому диалогу (overlay) или по элементу с классом modal__dialog — закрываем
            // защищаем доступ к classList (например, если target — текстовый узел)
            const target = e.target;
            const isModalDialogElem = target && target.classList && target.classList.contains('modal__dialog');
            if (isModalDialogElem || target === dialog) {
                closeAllModals();
            }
        });
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeAllModals();
    });
};

export default initModals;
